import React, { useEffect, useState } from "react";
import CarCard from "../components/CarCard";
import api from "../api/api"; // Updated import

function CarListingsPage() {
  const [cars, setCars] = useState([]);

  useEffect(() => {
    api.get("/cars") // Fetch all cars
      .then((response) => setCars(response.data))
      .catch((error) => console.error("Error fetching car listings:", error));
  }, []);

  return (
    <section className="cars">
      <div className="container">
        <h2>Available Cars</h2>
        <div className="car-grid">
          {cars.map((car) => (
            <CarCard key={car.id} car={car} />
          ))}
        </div>
      </div>
    </section>
  );
}

export default CarListingsPage;
